<div class="sm-page">

    <div class="d-flex align-items-center flex-wrap sm-title">
        <h5 class="mb-0 mr-3">經紀公司人員(工作室)</h5>
        <span class="text-muted small">只列 vendor_member 標記為「工作室」成員的提領紀錄；這些人不會出現在一般對帳、勞報單與匯款單</span>
        <button class="btn btn-link btn-sm ml-auto" (click)="show_help = !show_help">
            <i class="fas fa-question-circle"></i> {{ show_help ? '收起說明' : '流程說明' }}
        </button>
    </div>

    <div class="alert alert-warning sm-help" *ngIf="show_help">
        <ol class="mb-1 pl-3">
            <li>成員身分在「經紀公司人員 → 人員列表 → 設定」切成<b>工作室</b>並填工作室名稱，之後她的提領列才會出現在這裡（一般對帳同時不再列出）。</li>
            <li>工作室每期會寄發票過來 → 在該列「發票」欄<b>上傳</b>圖片（jpg / png / gif；換圖會自動變回未核實）。</li>
            <li>會計核對發票金額與「實際結算金額」相符 → 按<b>核實</b>（點縮圖可開對照視窗，大圖旁邊就是應核金額）。沒核實的列：付款狀態不能改、也不會進匯款單／領現單。</li>
            <li>按「工作室匯款單／領現單」匯出當月 xls 給銀行或出納；匯出的月份用上方<b>開始月份</b>，可搭配團隊、工作室名稱過濾。<b>預設只出尚未付款的列</b>，要連已付款一起出請勾「含已付款」。</li>
            <li>放款後：直接在列上改付款狀態，或把匯出的 xls 填好「提領狀態」欄（0 尚未付款 / 1 付款成功 / 2 付款失敗）再從「匯入付款狀態」上傳回填；非工作室、發票未核實、查無、狀態值不合法的列會被跳過並列出 id。</li>
        </ol>
        <div class="small text-muted">
            提領方式 1 匯款 / 5 領現 會出帳；3、4 累積、-1 鎖定、0 試算中不出帳也不能付款。
            一旦進了付款流程（付款成功或付款失敗），提領方式、發票、核實都凍結；付款成功後鎖定不可改，付款失敗只能改成付款成功（與一般對帳相同）。
            付款狀態改動會連同該用戶更早的紀錄一起改，遇「累積已匯」停止。<b>重算薪資</b>會把該列的核實狀態歸零（金額變了要重新核對，發票圖保留）。
            預設只顯示對帳會用到的欄位，收入拆分、銀行與身分資料按「全部欄位」展開。
        </div>
    </div>

    <!-- 搜尋列 -->
    <div class="sm-bar">
        <select class="form-control sm-select" [(ngModel)]="vid" (change)="init_list()" title="只列出目前有工作室提領紀錄的團隊">
            <option *ngFor="let v of vendor_options" [ngValue]="v.id">{{ v.name }}</option>
        </select>
        <span class="sm-inline">
            開始月份 <input type="month" [(ngModel)]="current_month" class="form-control sm-month" (keyup.enter)="init_list()">
        </span>
        <span class="sm-inline">
            結束月份 <input type="month" [(ngModel)]="current_monthed" class="form-control sm-month" (keyup.enter)="init_list()">
        </span>
        <input type="text" class="form-control sm-input" [(ngModel)]="search_model" placeholder="名稱 / 實名 / 電話" (keyup.enter)="init_list()">
        <input type="text" class="form-control sm-input" [(ngModel)]="search_studio_name" placeholder="工作室名稱" (keyup.enter)="init_list()">
        <select class="form-control sm-select" [(ngModel)]="search_trasnfer_status" title="提領方式">
            <option value="">提領方式不限</option>
            <option value="1">匯款</option>
            <option value="5">領現</option>
            <option value="2">累積(未匯/已匯)</option>
        </select>
        <select class="form-control sm-select" [(ngModel)]="search_invoice_ok" title="發票">
            <option value="-1">發票不限</option>
            <option value="0">未核實</option>
            <option value="1">已核實</option>
        </select>
        <select class="form-control sm-select" [(ngModel)]="search_withdrawal_status" title="付款狀態">
            <option value="-1">付款狀態不限</option>
            <option value="0">尚未付款</option>
            <option value="1">付款成功</option>
            <option value="2">付款失敗</option>
        </select>
        <select class="form-control sm-select" [(ngModel)]="search_health_fee" title="健保">
            <option value="">健保不限</option>
            <option value="1">不需扣健保費</option>
        </select>
        <select class="form-control sm-select" [(ngModel)]="search_account_memo" title="會計備註">
            <option value="">備註不限</option>
            <option value="1">會計有備註</option>
        </select>
        <button class="btn btn-primary" (click)="init_list()"><i class="fas fa-search mr-1"></i>搜尋</button>
        <button class="btn" [ngClass]="filters_dirty ? 'btn-warning' : 'btn-outline-secondary'" (click)="reset_filters()" [title]="filters_dirty ? '目前是篩選過的結果，點我回到預設：上個月、全部團隊、不限' : '目前就是預設條件'">
            <i class="fas fa-filter mr-1" *ngIf="filters_dirty"></i>重設
        </button>
    </div>

    <!-- 匯出 / 匯入 -->
    <div class="sm-bar sm-actions">
        <!-- 沒開始月份就不給 href 並上 disabled（Bootstrap 會擋 pointer-events），不然會開出一個只寫「請指定月份」的分頁 -->
        <a [attr.href]="current_month ? export_wd_url : null" [class.disabled]="!current_month" target="_blank" class="btn btn-success text-nowrap" [title]="current_month ? '只含發票已核實、提領方式為匯款' + (include_paid ? '' : '、尚未付款') + '的列' : '請先選開始月份'">
            <i class="fas fa-money-check mr-1"></i>工作室匯款單 {{ current_month || '（請選月份）' }}
        </a>
        <a [attr.href]="current_month ? export_cash_url : null" [class.disabled]="!current_month" target="_blank" class="btn btn-success text-nowrap" [title]="current_month ? '只含發票已核實、提領方式為領現' + (include_paid ? '' : '、尚未付款') + '的列' : '請先選開始月份'">
            <i class="fas fa-hand-holding-usd mr-1"></i>工作室領現單 {{ current_month || '（請選月份）' }}
        </a>
        <label class="sm-inline mb-0 small" title="不勾：只出尚未付款的列（給銀行 / 出納用）；勾了：連已付款、付款失敗的也一起出（對帳留底用）">
            <input type="checkbox" [(ngModel)]="include_paid"> 含已付款
        </label>
        <label class="btn btn-info text-nowrap mb-0" title="上傳填好「提領狀態」欄的匯款單 / 領現單 xls">
            <i class="fas fa-file-upload mr-1"></i>匯入付款狀態
            <input type="file" accept=".xlsx,.xls,.csv" (change)="upload_excel($event)" style="display:none">
        </label>
        <span class="text-muted small">匯出以「開始月份」為準{{ include_paid ? '' : '、只出尚未付款' }}{{ vid !== '-1' ? '，僅目前選的團隊' : '' }}{{ search_studio_name ? '，工作室名稱含「' + search_studio_name + '」' : '' }}</span>
    </div>

    <!-- 筆數 + 進度統計 / 欄位模式 / 每頁筆數 -->
    <div class="sm-bar sm-meta">
        <span class="sm-inline">
            共 <b>{{ pageobj.total_count }}</b> 筆
            <span class="text-danger ml-2" *ngIf="load_msg">{{ load_msg }}</span>
        </span>
        <span class="sm-summary sm-inline" *ngIf="data_all.length > 0" title="目前查詢結果的統計">
            <!-- 由左到右照付款流程走：未付總額 → 待上傳發票 → 待核實 → 可付款 → 付款失敗 / 凍結 → 已付款；累積列不出帳放最後 -->
            <span class="badge badge-light" title="會出帳（匯款 / 領現）且還沒付款成功的列（含付款失敗），不論發票有沒有核實；累積列不算（金額會滾進之後某一期）" *ngIf="summary.unpaid_rows">未付合計 {{ fmt(summary.unpaid_sum) }} 元（{{ summary.unpaid_rows }} 筆）</span>
            <span class="badge badge-secondary" title="會出帳、尚未付款、還沒收到發票的列" *ngIf="summary.no_invoice">待上傳發票 {{ summary.no_invoice }}</span>
            <span class="badge badge-warning" title="已上傳發票，等會計核對" *ngIf="summary.awaiting">待核實 {{ summary.awaiting }}</span>
            <span class="badge badge-info" title="發票已核實、尚未付款：這就是匯款單 / 領現單會出的金額" *ngIf="summary.ready">可付款 {{ summary.ready }}（{{ fmt(summary.ready_sum) }} 元）</span>
            <span class="badge badge-danger" title="付款失敗（發票已核實，可在列上改成付款成功；匯出時要勾「含已付款」才會出現）" *ngIf="summary.failed">付款失敗 {{ summary.failed }}（{{ fmt(summary.failed_sum) }} 元）</span>
            <span class="badge badge-dark" title="付款失敗但發票未核實：後端凍結發票、付款又要核實，兩邊都動不了，請找工程處理" *ngIf="summary.stuck"><i class="fas fa-exclamation-triangle"></i> 凍結待處理 {{ summary.stuck }}</span>
            <span class="badge badge-primary" title="付款成功的出帳列" *ngIf="summary.paid">已付款 {{ summary.paid }}（{{ fmt(summary.paid_sum) }} 元）</span>
            <span class="badge badge-light" *ngIf="summary.accum_rows" title="累積未匯 / 累積已匯：不出帳，發票也不用在這期收">累積 {{ summary.accum_rows }}</span>
        </span>
        <span class="ml-auto sm-inline">
            <button class="btn btn-sm btn-outline-secondary" (click)="toggle_cols()" [title]="show_all_cols ? '只留對帳會用到的 9 欄' : '展開收入拆分、銀行與身分資料'">
                <i class="fas" [ngClass]="show_all_cols ? 'fa-compress-alt' : 'fa-expand-alt'"></i>
                {{ show_all_cols ? '精簡欄位' : '全部欄位' }}
            </button>
            每頁
            <select class="form-control form-control-sm sm-page-size" [ngModel]="pageobj.count" (ngModelChange)="set_page_size($event)">
                <option *ngFor="let n of page_size_options" [ngValue]="n">{{ n }}</option>
            </select>
            筆
        </span>
    </div>

    <!-- 同一份格子在桌機 / 手機兩個模板共用 -->
    <ng-template #cell let-row let-key="key">
        <ng-container [ngSwitch]="key">

            <span *ngSwitchCase="'name'">
                <div>{{ row.name || '未填寫' }}</div>
                <div class="small text-muted">{{ row.phone_num }}</div>
            </span>

            <span *ngSwitchCase="'baccount'">
                <div>{{ row.baccount }}</div>
                <div class="small text-info" *ngIf="row._acc_memo">{{ row._acc_memo }}</div>
            </span>

            <span *ngSwitchCase="'opt'">
                <span *ngIf="row.transfer_status == 3 || row.transfer_status == 4 || row.transfer_status == -1 || row.transfer_status == 0" class="badge badge-secondary sm-badge">
                    {{ transfer_label(row.transfer_status) }}
                </span>
                <!-- 進付款流程後（aws≠0）後端不給切，這裡只顯示現況 -->
                <span *ngIf="payable_ts(row) && !editable(row)">
                    <span class="badge badge-secondary sm-badge">{{ transfer_label(row.transfer_status) }}</span>
                    <div class="small text-muted text-nowrap"><i class="fas fa-lock"></i> {{ transfer_lock_reason(row) }}</div>
                </span>
                <span *ngIf="payable_ts(row) && editable(row)" class="text-nowrap">
                    <button class="btn btn-sm" [ngClass]="(row.transfer_status == 1 || row.transfer_status == 2) ? 'btn-primary' : 'btn-secondary'" [disabled]="row._busy" (click)="set_transfer(row, 1)">匯款</button>
                    <button class="btn btn-sm ml-1" [ngClass]="row.transfer_status == 5 ? 'btn-primary' : 'btn-secondary'" [disabled]="row._busy" (click)="set_transfer(row, 5)">領現</button>
                </span>
            </span>

            <span *ngSwitchCase="'invoice'">
                <div class="sm-invoice">
                    <img *ngIf="is_http_url(row.invoice)" [src]="row.invoice" loading="lazy" class="sm-invoice-thumb" title="點我開對照視窗（大圖＋應核金額）" (click)="open_preview(row)">
                    <span *ngIf="row.invoice && !is_http_url(row.invoice)" class="badge badge-danger sm-badge" [title]="row.invoice">發票網址異常</span>
                    <span *ngIf="!row.invoice" class="badge badge-light sm-badge">未上傳</span>
                    <!-- 進付款流程後（aws≠0）發票凍結：不給上傳 / 換圖 / 移除 -->
                    <div class="sm-invoice-btns" *ngIf="editable(row)">
                        <label class="btn btn-sm btn-outline-primary mb-0" [class.disabled]="row._busy" title="上傳 / 換發票圖片（jpg / png / gif，4MB 內）">
                            <i class="fas" [ngClass]="row._busy ? 'fa-spinner fa-spin' : 'fa-upload'"></i> {{ row.invoice ? '換圖' : '上傳' }}
                            <input type="file" accept=".jpg,.jpeg,.png,.gif,image/jpeg,image/png,image/gif" [disabled]="row._busy" (change)="upload_invoice($event, row)" style="display:none">
                        </label>
                        <button *ngIf="row.invoice" class="btn btn-sm btn-outline-danger ml-1" title="移除發票" [disabled]="row._busy" (click)="clear_invoice(row)"><i class="fas fa-trash-alt"></i></button>
                    </div>
                    <div class="small text-muted text-nowrap" *ngIf="!editable(row)"><i class="fas fa-lock"></i> {{ invoice_lock_reason(row) }}</div>
                </div>
            </span>

            <span *ngSwitchCase="'invoice_ok'">
                <span *ngIf="row.invoice_ok == 1" class="text-nowrap">
                    <span class="badge badge-success sm-badge"><i class="fas fa-check"></i> 已核實</span>
                    <button *ngIf="editable(row)" class="btn btn-sm btn-link text-danger p-0 ml-1" [disabled]="row._busy" (click)="set_invoice_ok(row, 0)">取消</button>
                </span>
                <span *ngIf="row.invoice_ok != 1 && row.invoice" class="text-nowrap">
                    <span class="badge badge-warning sm-badge">未核實</span>
                    <button *ngIf="editable(row)" class="btn btn-sm btn-success ml-1" [disabled]="row._busy" title="確認發票金額與實際結算金額相符" (click)="set_invoice_ok(row, 1)">核實</button>
                </span>
                <span *ngIf="row.invoice_ok != 1 && !row.invoice" class="small text-muted text-nowrap" [title]="!payable_ts(row) && editable(row) ? '這列的金額會滾進之後某一期，發票等那期出帳時再收即可' : ''">
                    <i class="fas fa-file-invoice"></i> {{ !editable(row) ? '無發票' : (payable_ts(row) ? '先上傳發票' : '累積列免發票') }}
                </span>
            </span>

            <span *ngSwitchCase="'actual_withdrawal_status'">
                <!-- 鎖住時只顯示目前狀態＋原因（三顆灰按鈕看不出哪個是現況）；可改時才顯示按鈕，規則同一般對帳頁：0 可任改、2 只能→1、1 鎖死 -->
                <ng-container *ngIf="payment_lock_reason(row) as reason; else payBtns">
                    <span class="badge sm-badge" [ngClass]="payment_badge_cls(row.actual_withdrawal_status)">{{ payment_label(row.actual_withdrawal_status) }}</span>
                    <div class="small text-muted text-nowrap"><i class="fas fa-lock"></i> {{ reason }}</div>
                </ng-container>
                <ng-template #payBtns>
                    <span class="text-nowrap">
                        <button *ngIf="row.actual_withdrawal_status == 0 || payment_allowed(row, 0)" class="btn btn-sm" [ngClass]="row.actual_withdrawal_status == 0 ? 'btn-primary' : 'btn-secondary'" [disabled]="row._busy" (click)="set_payment(row, 0)">尚未付款</button>
                        <button *ngIf="row.actual_withdrawal_status == 1 || payment_allowed(row, 1)" class="btn btn-sm ml-1" [ngClass]="row.actual_withdrawal_status == 1 ? 'btn-primary' : 'btn-secondary'" [disabled]="row._busy" (click)="set_payment(row, 1)">付款成功</button>
                        <button *ngIf="row.actual_withdrawal_status == 2 || payment_allowed(row, 2)" class="btn btn-sm ml-1" [ngClass]="row.actual_withdrawal_status == 2 ? 'btn-primary' : 'btn-secondary'" [disabled]="row._busy" (click)="set_payment(row, 2)">付款失敗</button>
                    </span>
                </ng-template>
            </span>

            <span *ngSwitchDefault>{{ row[key] }}</span>
        </ng-container>
    </ng-template>

    <!-- 第一次載入顯示載入中；查無資料給提示與捷徑；有資料才放表格（之後的重抓靠整頁遮罩） -->
    <div *ngIf="!loaded_once" class="sm-loading text-muted">
        <i class="fas fa-spinner fa-spin mr-2"></i>載入中…
    </div>
    <div *ngIf="loaded_once && data_all.length === 0" class="sm-empty">
        <div class="sm-empty-title"><i class="far fa-folder-open mr-2"></i>這個條件下沒有工作室成員的提領紀錄</div>
        <div class="small text-muted">
            成員要先在「經紀公司人員 → 人員列表 → 設定」把身分切成工作室，她的提領列才會出現在這裡；
            或放寬月份、改選「全部團隊」。
        </div>
        <button class="btn btn-sm btn-outline-primary mt-2" (click)="search_all_months()" *ngIf="current_month">改查全部月份</button>
        <button class="btn btn-sm btn-outline-secondary mt-2 ml-1" (click)="reset_filters()">回預設條件</button>
    </div>
    <ng-container *ngIf="loaded_once && data_all.length > 0">
        <r-table [data]="posts_input" (callback)="on_sort($event)">
            <ng-template let-post #operation_dk>
                <ng-container *ngTemplateOutlet="cell; context: { $implicit: data[post.idx], key: post.key }"></ng-container>
            </ng-template>
            <ng-template let-post #operation_mb>
                <ng-container *ngTemplateOutlet="cell; context: { $implicit: data[post.idx], key: post.key }"></ng-container>
            </ng-template>
        </r-table>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    </ng-container>

</div>

<!-- 發票對照視窗：大圖 + 應核金額 + 核實按鈕（Swal 的 z-index 1060 會蓋在它上面） -->
<div class="sm-overlay" *ngIf="preview" (click)="close_preview()">
    <div class="sm-overlay-box" (click)="$event.stopPropagation()">
        <div class="sm-overlay-head">
            <div class="sm-overlay-who">
                <b>{{ preview.name }}</b>
                <span class="text-muted small ml-2">{{ preview.vendor_name }}<span *ngIf="preview.studio_name"> / {{ preview.studio_name }}</span> · 結算 {{ preview.actual_withdrawal_time }}</span>
            </div>
            <span class="sm-overlay-nav" *ngIf="preview_pos().n > 1">
                <button class="btn btn-sm btn-outline-secondary" title="上一張 (←)" (click)="preview_nav(-1)"><i class="fas fa-chevron-left"></i></button>
                <span class="small text-muted">{{ preview_pos().i + 1 }} / {{ preview_pos().n }}</span>
                <button class="btn btn-sm btn-outline-secondary" title="下一張 (→)" (click)="preview_nav(1)"><i class="fas fa-chevron-right"></i></button>
            </span>
            <div class="sm-overlay-amt">實際結算金額 <b>{{ fmt(preview.real_money) }}</b> 元</div>
            <button type="button" class="close ml-3" title="關閉 (Esc)" (click)="close_preview()">&times;</button>
        </div>
        <div class="sm-overlay-body">
            <img *ngIf="is_http_url(preview.invoice)" [src]="preview.invoice" class="sm-overlay-img" alt="發票">
            <div *ngIf="!is_http_url(preview.invoice)" class="text-white p-4">發票網址異常，無法顯示</div>
        </div>
        <div class="sm-overlay-foot">
            <span *ngIf="preview.invoice_ok == 1" class="badge badge-success sm-badge"><i class="fas fa-check"></i> 已核實</span>
            <span *ngIf="preview.invoice_ok != 1" class="badge badge-warning sm-badge">未核實</span>
            <ng-container *ngIf="editable(preview)">
                <button *ngIf="preview.invoice_ok != 1" class="btn btn-success btn-sm ml-2" [disabled]="preview._busy" (click)="set_invoice_ok(preview, 1)"><i class="fas fa-check mr-1"></i>金額相符，核實</button>
                <button *ngIf="preview.invoice_ok == 1" class="btn btn-outline-danger btn-sm ml-2" [disabled]="preview._busy" (click)="set_invoice_ok(preview, 0)">取消核實</button>
            </ng-container>
            <span *ngIf="!editable(preview)" class="small text-muted ml-2"><i class="fas fa-lock"></i> {{ invoice_lock_reason(preview) }}</span>
            <a *ngIf="is_http_url(preview.invoice)" [href]="preview.invoice" target="_blank" class="btn btn-link btn-sm">另開原圖</a>
            <button class="btn btn-secondary btn-sm ml-auto" (click)="close_preview()">關閉</button>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
